/**
 * Jurident Payment Configuration
 * This file manages test and production URLs for PhonePe payments
 *
 * To switch between test and production:
 * 1. Set isTestMode to true for testing
 * 2. Set isTestMode to false for production
 */

class JuridentPaymentConfig {
  // ==========================================
  // ENVIRONMENT TOGGLE
  // ==========================================
  // Set this to true for testing, false for production
  static isTestMode =  false; // 👈 Set to true for testing, false for production

  // ==========================================
  // TEST CONFIGURATION
  // ==========================================
  static testPhonePeUrl = 'https://phone-pay-payment-gateway-node-js.vercel.app/api/payment';
  static testCloudFunctionUrl = 'https://us-central1-valsco-jurident.cloudfunctions.net/updateIOSSubscription';

  // ==========================================
  // PRODUCTION CONFIGURATION
  // ==========================================
  static prodPhonePeUrl = 'https://phone-pay-payment-gateway-node-js.vercel.app/api/payment';
  static prodCloudFunctionUrl = 'https://us-central1-valsco-jurident.cloudfunctions.net/updateIOSSubscription';

  // ==========================================
  // GETTERS - Automatically returns correct URLs based on mode
  // ==========================================

  /**
   * Returns current PhonePe payment API URL based on environment
   */
  static get phonePeUrl() {
    return this.isTestMode ? this.testPhonePeUrl : this.prodPhonePeUrl;
  }

  /**
   * Returns current Cloud Function URL based on environment
   */
  static get cloudFunctionUrl() {
    return this.isTestMode ? this.testCloudFunctionUrl : this.prodCloudFunctionUrl;
  }

  /**
   * Returns environment display name for UI
   */
  static get environmentName() {
    return this.isTestMode ? '🧪 TEST MODE' : '🚀 PRODUCTION';
  }

  /**
   * Returns environment badge color
   */
  static get environmentColor() {
    return this.isTestMode ? '#ffc107' : '#4caf50';
  }

  // ==========================================
  // APP COLOR SCHEME (matching Flutter app)
  // ==========================================
  static colors = {
    primary: '#C99F4A',      // Golden/Amber (from Flutter app)
    primaryDark: '#A88338',  // Darker shade for hover states
    primaryLight: '#D4B166', // Lighter shade for backgrounds
    success: '#4caf50',      // Success green
    error: '#dc3545',        // Error red
    warning: '#ffc107',      // Warning amber
    text: '#333333',         // Primary text
    textLight: '#666666',    // Secondary text
    background: '#f8f9fa',   // Light background
    white: '#ffffff',
    border: '#e0e0e0',
  };

  // ==========================================
  // DEBUG HELPERS
  // ==========================================

  /**
   * Print current configuration (for debugging)
   */
  static printCurrentConfig() {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('📱 JURIDENT PAYMENT CONFIGURATION');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('Environment:', this.environmentName);
    console.log('Mode:', this.isTestMode ? 'TEST' : 'PRODUCTION');
    console.log('PhonePe URL:', this.phonePeUrl);
    console.log('Cloud Function URL:', this.cloudFunctionUrl);
    console.log('Primary Color:', this.colors.primary);
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  }

  /**
   * Get configuration as JSON (for logging)
   */
  static toJson() {
    return {
      isTestMode: this.isTestMode,
      environmentName: this.environmentName,
      phonePeUrl: this.phonePeUrl,
      cloudFunctionUrl: this.cloudFunctionUrl,
      colors: this.colors,
    };
  }
}

export default JuridentPaymentConfig;
